export function Section({ children, className = "", id }) {
  return (
    <section id={id} className={`py-24 md:py-32 ${className}`}>
      <div className="container-x">{children}</div>
    </section>
  );
}

export function Overline({ children, className = "" }) {
  return <p className={`overline ${className}`}>{children}</p>;
}

export function SectionHeading({ eyebrow, title, intro, align = "left" }) {
  const alignCls = align === "center" ? "text-center mx-auto" : "";
  return (
    <div className={`max-w-3xl ${alignCls}`}>
      {eyebrow && <Overline className="mb-4">{eyebrow}</Overline>}
      <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-[1.1] text-foreground">
        {title}
      </h2>
      {intro && (
        <p className="mt-5 text-lg md:text-xl leading-relaxed text-muted-foreground">
          {intro}
        </p>
      )}
    </div>
  );
}
